import { useMutation } from '@tanstack/react-query';

import { deleteEmailTemplate } from '../api';

export const useDeleteEmailTemplate = () => {
  return useMutation({
    mutationFn: deleteEmailTemplate,
    onSuccess: () => {},
    onError: () => {},
  });
};
